/**
 * Where a view's content lies in the layout, in viewport px. The content slides in on a document
 * change (a transform on it); what is placed on the content stays where the content comes to rest,
 * so the content's own transform does not count. A shown main pane narrows the box to the pane's
 * room: the navigation or list pane before it is not the content's main view.
 */
export function viewContentBox(
  content: HTMLElement,
  mainPane?: HTMLElement | null
) {
  const frame = content.offsetParent;
  const origin = frame?.getBoundingClientRect() ?? { left: 0, top: 0 };
  const left = origin.left + (frame?.clientLeft ?? 0) + content.offsetLeft;
  const top = origin.top + (frame?.clientTop ?? 0) + content.offsetTop;
  const bottom = top + content.offsetHeight;
  if (!mainPane?.offsetWidth)
    return { left, width: content.offsetWidth, bottom };
  // The content's slide moves the pane alike, so its offset in the content holds.
  const start =
    mainPane.getBoundingClientRect().left -
    content.getBoundingClientRect().left;
  return { left: left + start, width: mainPane.offsetWidth, bottom };
}
